module.exports = __webpack_public_path__ + "static/img/09.dc5f6cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/huegler/09.jpg
// module id = 383
// module chunks = 1